// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"4387dab1","247":"2a0b71d7","285":"da0bc872"}[chunkId] + ".css";
};